import script from "./SculpturePour.vue?vue&type=script&setup=true&lang=ts"
export * from "./SculpturePour.vue?vue&type=script&setup=true&lang=ts"

import "./SculpturePour.vue?vue&type=style&index=0&id=a630b9f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.4_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a630b9f8"]])

export default __exports__